import React from 'react'
import { BootstrapData } from '../../types'

const BootstrapDataContext = React.createContext<BootstrapData>(
    {} as BootstrapData
  )

export default BootstrapDataContext
